export default __webpack_public_path__ + "fonts/campton-book-webfont.woff2";